import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { injectIntl, defineMessages } from 'react-intl';
import { Modal, ModalBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

import env from 'Env';
import AddToCartBtn from 'Components/Cards/AddToCartBtn';
import SpecialFormattedNumber from 'Components/Utility/Price/SpecialFormattedNumber';
import Price from 'Components/Utility/Price/Price';
import FluidImg from 'Components/Utility/FluidImg';
import DangerousHTML from 'Components/Utility/DangerousHTML';
import imgixConfig from 'Config/imgix';
import Video from 'Components/Utility/Video';

import 'Components/Product/ProductOffers/PreorderBonus.scss';

const messages = defineMessages({
  addtocart: {
    id: 'preorder-bonus.details.button.add',
    defaultMessage: 'Add to cart',
  },
});

function PreorderBonus({
  intl,
  product,
  preorderGraphic,
}) {
  const [openModal, setOpenModal] = useState(false);

  const { formatMessage } = intl;

  const name = get(product, 'name', '');
  const productId = get(product, '_id', '');
  const slug = get(product, 'slug', '');
  const discount = get(product.current_discount, 'percent', 0);
  const price = get(product, 'price', {});
  const bonusBanner = get(product, 'preorder_bonus_banner', '');
  const preorderDesc = get(product, 'preorder_info', '');
  const preorderCover = get(product, 'preorderCover', '');
  const preorderVideos = get(product, 'preorderVideo', []);
  const preorderVideo = preorderVideos[0] || '';

  const preorderBonusBannerImg = `${env.cdnUrl}/product/original/${bonusBanner}`;

  const useModal = preorderCover || preorderVideo;

  return (
    <React.Fragment>
      <div className="offer-banner preorder-bonus-banner-img">
        {useModal &&
          <button className="btn-reset-style" onClick={() => setOpenModal(!openModal)}>
            {!preorderGraphic &&
              <img
                srcSet={`
                  ${preorderBonusBannerImg}?${imgixConfig}&w=1292&h=340&fit=crop 1292w,
                  ${preorderBonusBannerImg}?${imgixConfig}&w=704&h=185&fit=crop 704w,
                  ${preorderBonusBannerImg}?${imgixConfig}&w=646&h=170&fit=crop 646w,
                  ${preorderBonusBannerImg}?${imgixConfig}&w=578&h=144&fit=crop 578w,
                  ${preorderBonusBannerImg}?${imgixConfig}&w=524&h=138&fit=crop 524w,
                  ${preorderBonusBannerImg}?${imgixConfig}&w=460&h=121&fit=crop 460w
                `}
                sizes="(min-width: 1520px) 646px, (min-width: 1200px) 578px, (min-width: 992px) 460px, (min-width: 768px) 704px, (min-width: 576px) 524px, 95vw"
                src={`${preorderBonusBannerImg}?${imgixConfig}&w=646&h=170&fit=crop`}
                alt={bonusBanner}
                loading="lazy"
                fetchpriority="low"
                decoding="async"
              />
            }
            {preorderGraphic &&
              <FluidImg
                src={preorderCover}
                alt={name}
                sizesOverride={'(min-width: 1520px) 747px, (min-width: 1200px) 608px, (min-width: 992px) 528px, (min-width: 768px) 640px,  (min-width: 576px) 476px, 98vw'}
              />
            }
          </button>
        }
        {!useModal &&
          <div className="btn-reset-style">
            {!preorderGraphic &&
              <img
                srcSet={`
                  ${preorderBonusBannerImg}?${imgixConfig}&w=1292&h=340&fit=crop 1292w,
                  ${preorderBonusBannerImg}?${imgixConfig}&w=704&h=185&fit=crop 704w,
                  ${preorderBonusBannerImg}?${imgixConfig}&w=646&h=170&fit=crop 646w,
                  ${preorderBonusBannerImg}?${imgixConfig}&w=578&h=144&fit=crop 578w,
                  ${preorderBonusBannerImg}?${imgixConfig}&w=524&h=138&fit=crop 524w,
                  ${preorderBonusBannerImg}?${imgixConfig}&w=460&h=121&fit=crop 460w
                `}
                sizes="(min-width: 1520px) 646px, (min-width: 1200px) 578px, (min-width: 992px) 460px, (min-width: 768px) 704px, (min-width: 576px) 524px, 95vw"
                src={`${preorderBonusBannerImg}?${imgixConfig}&w=646&h=170&fit=crop`}
                alt={bonusBanner}
                loading="lazy"
                fetchpriority="low"
                decoding="async"
              />
            }
            {preorderGraphic &&
              <FluidImg
                src={preorderCover}
                alt={name}
                sizesOverride={'(min-width: 1520px) 747px, (min-width: 1200px) 608px, (min-width: 992px) 528px, (min-width: 768px) 640px,  (min-width: 576px) 476px, 98vw'}
              />
            }
          </div>
        }
      </div>

      {useModal &&
        <Modal isOpen={openModal} toggle={() => setOpenModal(!openModal)} className="video-modal">
          <ModalBody>
            <div className="w-100 m-3">
              {preorderCover && !preorderVideo &&
                <FluidImg
                  src={preorderCover}
                  alt="Preorder Product Cover"
                  sizesOverride={'(min-width: 1200px) 820px, (min-width: 992px) 740px, (min-width: 768px) 540px, (min-width: 576px) 440px, 98vw'}
                  className="preorder-graphic"
                />
              }
              {preorderVideo &&
                <div className="video-wrapper">
                  <Video width="100%" height="auto" src={preorderVideo} className="youtube-video" />
                </div>
              }
            </div>

            {preorderDesc &&
              <React.Fragment>
                <div className="pre-order-description">
                  <DangerousHTML html={preorderDesc === null ? '' : preorderDesc} />
                </div>

                <div className="divider w-100 mt-2" />
              </React.Fragment>
            }

            <div className="purchase-details-container">
              <div className="game-title">
                {name}
              </div>
              <div className="price-button-container">
                <div className="price-container">
                  {discount > 0 &&
                    <React.Fragment>
                      <div className="game-discount">
                        {/* eslint-disable react/style-prop-object */}
                        -<SpecialFormattedNumber value={discount} style="percent" />
                      </div>
                      <div className="game-was-price">
                        <Price price={price} />
                      </div>
                    </React.Fragment>
                  }
                  <div className="game-current-price">
                    <Price price={price} discount={discount} />
                  </div>
                </div>
                <AddToCartBtn
                  quickLook
                  modalToggle={() => setOpenModal(!openModal)}
                  id={productId}
                  slug={slug}
                  buttonText={formatMessage(messages.addtocart)}
                />
              </div>
            </div>
          </ModalBody>

          <div className="close-button-container">
            <button aria-label="close" onClick={() => setOpenModal(!openModal)}>
              <FontAwesomeIcon icon={faXmark} title="Close modal" />
            </button>
          </div>
        </Modal>
      }
    </React.Fragment>
  );
}

PreorderBonus.propTypes = {
  product: PropTypes.shape({}),
  preorderGraphic: PropTypes.bool,
};

PreorderBonus.defaultProps = {
  product: {},
  preorderGraphic: false,
};

export default injectIntl(PreorderBonus);
